export class TwoFactorAuth
{
    Status : number;
    Code : string;
    SentAt : string;
    SentTo :string;
    Message : string;
    ReceivedAt : Date;
    DeviceIdentifier : string;
    UserId: number;

    constructor(
        Status: number,
        Code : string,
        SentAt : string,
        SentTo :string,
        Message : string,
        ReceivedAt : Date,
        DeviceIdentifier : string,
        UserId: number)
        {
            this.Status = Status;
            this.Code = Code;
            this.SentAt = SentAt;
            this.SentTo = SentTo;
            this.Message = Message;
            this.ReceivedAt = ReceivedAt;
            this.DeviceIdentifier = DeviceIdentifier;
            this.UserId = UserId;
        }
    
}